import React from 'react';
import cx from 'classnames';

type Props = {
  spinning?: boolean;
  disabled?: boolean;
  text: string;
  type?: 'submit' | 'reset' | 'button' | undefined;
  className?: string;
  onClick?: () => void;
};

const SubmitButton = ({
  text,
  disabled = false,
  spinning = false,
  type = 'submit',
  className = '',
  onClick,
}: Props) => {
  return (
    <button
      onClick={onClick}
      type={type}
      disabled={spinning || disabled}
      className={cx(
        className.length === 0 ? 'flex' : className,
        disabled ? 'not-allowed' : null
      )}
    >
      {spinning && (
        <React.Fragment>
          <svg className='animate-spin h-5 w-5 mr-3 ...' viewBox='0 0 24 24'>
            <circle
              className='opacity-25'
              cx='12'
              cy='12'
              r='10'
              stroke='currentColor'
              strokeWidth='4'
            ></circle>
            <path
              className='opacity-75'
              fill='currentColor'
              d='M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z'
            ></path>
          </svg>
        </React.Fragment>
      )}
      {text}
    </button>
  );
};

export default SubmitButton;
